import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  List,
  ListItem,
  Flex,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ChakraProvider,
  useToast,
  Select,
  position,
} from "@chakra-ui/react";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

const AddDesignation = ({ positions, departments, onDataChange }) => {
  const [name, setName] = useState("");
  const [dept, setDept] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
  const [designationToDelete, setDesignationToDelete] = useState(null);
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/HumanResource/api/positions/add/`, { name, dept });
      toast({
        title: "Designation created successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      onDataChange();
      setName("");
      setDept("");
    } catch (error) {
      console.error("Error creating designation:", error);
      toast({
        title: "An error occurred while creating the designation. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleDelete = (designation) => {
    setDesignationToDelete(designation);
    setIsDeleteConfirmationOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/HumanResource/api/positions/delete/${designationToDelete.id}/`);
      toast({
        title: "Designation deleted successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      onDataChange();
      setIsDeleteConfirmationOpen(false);
    } catch (error) {
      console.error("Error deleting designation:", error);
      toast({
        title: "An error occurred while deleting the designation. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleEdit = (designation) => {
    setSelectedDesignation({ ...designation, dept: { id: designation.dept } });
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setSelectedDesignation(null);
    setIsEditModalOpen(false);
  };

  const handleSaveEdit = async () => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/HumanResource/api/positions/update/${selectedDesignation.id}/`, {
        name: selectedDesignation.name,
        dept: selectedDesignation.dept.id,
      });
      toast({
        title: "Designation updated successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setIsEditModalOpen(false);
      onDataChange();
    } catch (error) {
      console.error("Error updating designation:", error);
      toast({
        title: "An error occurred while updating the designation. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const [userStatus, setUserStatus] = useState(false);
  const [isSuperuser, setIsSuperUser] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/HumanResource/user-status/`);
        if (response.status === 200) {
          console.log("Response: ", response.data)
          setUserStatus(response.data);
          setIsSuperUser(response.data.is_superuser);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  return (
    <ChakraProvider>
      <Box maxW="md" mx="auto" mt="8" borderWidth="1px" borderRadius="lg" className="addDepartmentStyling">
        <h5 className="departmentHeading">Add Designation</h5>
        <form onSubmit={handleSubmit}>
          <div className="inputBox">
            <FormControl id="designationName">
              <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Designation Name" />
            </FormControl>
            <FormControl id="deptName" my="3">
              <Select value={dept} onChange={(e) => setDept(e.target.value)} placeholder="Select Department">
                {departments.map((dept) => (
                  <option key={dept.id} value={dept.id}>
                    {dept.name}
                  </option>
                ))}
              </Select>
            </FormControl>
            <Button colorScheme="blue" type="submit">
              Save
            </Button>
          </div>
        </form>
        <div className="departmentData">
          <List mt="4">
            {positions.map((designation) => (
              <ListItem key={designation.id} borderBottom="1px solid #ccc" style={{paddingTop:"7px", paddingBottom:"7px"}}>
                <Flex align="center" justify="space-between">
                  {designation.name}
                  {isSuperuser && (
                  <Flex>
                    <IconButton aria-label="Edit" icon={<EditIcon />} mr="2" onClick={() => handleEdit(designation)} />
                    <IconButton aria-label="Delete" icon={<DeleteIcon />} onClick={() => handleDelete(designation)} />
                  </Flex>
                  )}
                </Flex>
              </ListItem>
            ))}
          </List>
        </div>
        <Modal isOpen={isEditModalOpen} onClose={handleCloseEditModal}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Edit Designation</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel>Designation Name</FormLabel>
                <Input
                  type="text"
                  value={selectedDesignation ? selectedDesignation.name : ""}
                  onChange={(e) => setSelectedDesignation({ ...selectedDesignation, name: e.target.value })}
                  placeholder="Designation Name"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Department</FormLabel>
                <Select
                  value={selectedDesignation ? selectedDesignation.dept.id : ""}
                  onChange={(e) => setSelectedDesignation({ ...selectedDesignation, dept: { id: e.target.value } })}
                  placeholder="Select Department"
                >
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" onClick={handleSaveEdit}>
                Save
              </Button>
              <Button onClick={handleCloseEditModal}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal isOpen={isDeleteConfirmationOpen} onClose={() => setIsDeleteConfirmationOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Are you sure you want to delete {designationToDelete && designationToDelete.name}?
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="red" onClick={confirmDelete}>
                Yes
              </Button>
              <Button onClick={() => setIsDeleteConfirmationOpen(false)}>No</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </ChakraProvider>
  );
};

export default AddDesignation;
